import classNames from 'classnames';
import styles from './BlurbCard.module.scss';
import { Heading, GridCell, Container } from 'ui/components';
import { formatDate } from 'helpers/date';

export const BlurbCard: React.FC<Models.BlurbCard> = ({ link, className, heading, kicker, text, settings, date }) => {
	const desktopWidth = settings?.properties?.desktopWidth ?? '';
	const mobileWidth = settings?.properties?.mobileWidth ?? '';

	return (
		<Container width="Standard" className={classNames(styles.BlurbCard, className)}>
			<GridCell desktopWidth={desktopWidth} mobileWidth={mobileWidth}>
				<a className={styles.BlurbCard_link} href={link?.url} target={link?.target} title={link?.name}>
					<div className={styles.BlurbCard_textbox}>
						{kicker && <div className={styles.BlurbCard_kicker}>{kicker}</div>}
						<Heading headingLevel="h3">{heading}</Heading>
						{date && <div className={styles.BlurbCard_date}>{formatDate(date, 'dd.mm.yyyy')}</div>}
						<div className={styles.BlurbCard_text} dangerouslySetInnerHTML={{ __html: text }}></div>
					</div>
				</a>
			</GridCell>
		</Container>
	);
};
